import type { UploadOutcome } from '../api/contracts'

/**
 * Итог главного фото в операции хранится словом `true`/`false`: так его видит и тест, и слушатель. Источник — булев ответ
 * службы (подтверждено ли чтением из 1С); в слово он переводится ровно в одном месте — `mainPhotoOutcome`.
 */
export const MAIN_PHOTO_OUTCOMES = ['true', 'false'] as const
export type MainPhotoOutcome = (typeof MAIN_PHOTO_OUTCOMES)[number]

/** Все итоги, которые порт сообщает слушателю: загрузка — слова службы, главное фото — подтверждение. */
export type PhotoOutcome = UploadOutcome | MainPhotoOutcome

export const mainPhotoOutcome = (confirmed: boolean): MainPhotoOutcome => (confirmed ? 'true' : 'false')

/**
 * Что человек читает по итогу и считается ли запись выполненной. Единственное определение «запись не выполнена, хотя
 * ответ 200»: им пользуются и слушатель (статус операции), и селектор (строка статуса). `Record` по `PhotoOutcome`
 * не даст забыть новый итог.
 */
export const PHOTO_OUTCOME_VIEW: Readonly<Record<PhotoOutcome, { text: string; done: boolean }>> = {
  Written: { text: 'Фото загружено в 1С', done: true },
  AlreadyAttached: { text: 'Этот снимок уже есть у товара', done: true },
  SkippedNotPublished: { text: 'Набор присоединённых файлов не опубликован в 1С — фото не записано', done: false },
  true: { text: 'Главное фото подтверждено чтением из 1С', done: true },
  false: { text: 'Профиль базы не знает поля главного фото — в 1С ничего не изменено', done: false },
}

export const isPhotoOutcome = (value: string): value is PhotoOutcome => Object.hasOwn(PHOTO_OUTCOME_VIEW, value)
